
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { fetchList, deleteResource } from '@/api/resource';
import { listAllCate } from '@/api/resourceCategory';
import { Message } from 'element-ui';
import { wait } from '@/utils/wait';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {},
        categoryOptions: []
    },
    actions: {
        async getList({ dispatch, state }, payload) {
            await wait(dispatch, 'ums.resource.list', async function() {
                const { searchForm } = state;
                await dispatch('getData', {
                    caller: fetchList,
                    options: {
                        ...searchForm,
                        ...payload
                    }
                });
            })
        },
        async deleteResource({ dispatch }, payload) {
            await deleteResource(payload);
            Message({
				type: "success",
				message: "删除成功!"
            });
            dispatch('getList');
        },
        async getCateList({ commit }) {
            const response = await listAllCate();
            let cateList = response.data;
            let categoryOptions = [];
            for(let i=0;i<cateList.length;i++){
                let cate = cateList[i];
                categoryOptions.push({label:cate.name,value:cate.id});
            }
            commit('save', {
                categoryOptions
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/resource/list.js